import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActionItemUpdate } from '../../../../action-item-update';
import { UserstoryService } from '../../../../services/userstory.service';
import { first, merge, mergeMap, Observable, tap } from 'rxjs';
import { ProjectService } from '../../../../services/project.service';
import { SettingsService } from '../../../../services/settings.service';
import { Issue } from '../../../../models/issue';
import { Userstory } from '../../../../models/userstory';
import { IssueType } from '../../../../models/enums/issueType';

@Component({
  selector: 'app-action-item-update',
  templateUrl: './action-item-update.component.html',
  styleUrls: ['./action-item-update.component.scss']
  })
export class ActionItemUpdateComponent {

  @Input() public update: ActionItemUpdate;
  @Output() public remove = new EventEmitter<number>();

  public issue: Userstory;
  public issueType: string;

  private projectKey: string;
  private sprintId: number;
  private issues: Observable<Userstory[]>;

  constructor(
    private userStoryService: UserstoryService,
    private projectService: ProjectService,
    private settingsService: SettingsService,
  ) {
    this.projectKey = this.settingsService.getProjectName();
    this.sprintId = this.settingsService.getSprintId(this.projectKey);

    this.issues = merge(
      this.userStoryService.getIssuesFromSprint(this.projectKey, this.sprintId),
      this.userStoryService.getUserstoriesFromBacklog(this.projectKey, 'story, task, bug, epic')
    );
  }

  ngOnInit(): void {
    this.getIssue(this.update.id)
      .subscribe(issue => {
        this.issue = issue;
        this.issueType = IssueType[this.issue.issueType];
      }); // TODO what to do if we can't find the issue?
  }

  /**
   * Only issues in current sprint or in backlog are considered.
   * @param id {@link Issue.id}
   */
  private getIssue(id: number) {
    return this.issues.pipe(
      mergeMap(userStories => userStories),
      first(userStory => userStory.id === id),
    );
  }

  acceptUpdate() {
    this.projectService
      .getBoardStates(this.projectKey)
      .pipe(
        mergeMap(project => project.getAllStatuses()),
        tap(s => console.log('status', s)),
        first(status => status.name === this.update.status),
        tap(s => console.log('first status', s)),
      ).subscribe(status => {
        const issue = this.issue.getCopy();
        issue.status = status;

        this.remove.emit(this.update.id); // remove update from copilot widget

        this.userStoryService.updateIssue(
          this.projectKey,
          this.issue.id,
          issue,
          false,
        );
      });
  }

  rejectUpdate() {
    this.remove.emit(this.update.id);
  }
}
